import React from "react";
import { useState,useEffect } from "react";
import CustomCsPcInput from "../../components/dms_common/CustomCsPcInput";
import {FormControl, Select, MenuItem} from "@mui/material";
import {  SalesReasonDetails } from "../../types/types";
import { getUomLabel } from "../../components/dms_common/DmsUtils";
import { useLocation } from "react-router-dom";
import { QuantityReason } from "./PrimaryReturnUtils";


const PrimaryReturnReasonSelect = (props:{currentErrorObj:any, validate:ValidateFunctionType,reasonObject:QuantityReason, onChange:(data:QuantityReason)=>void, actionElement:JSX.Element, products: any, selectedQuantity: string})=>{

    const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") || "{}");
    const {caseUnitLabelPrimaryReturn, otherUnitLabelPrimaryReturn, packUnitLabelPrimaryReturn} = ConfigDictionary;

    const reasonArray:string[] = ConfigDictionary.primaryReturnReasons ?? ["Quality Issues","Expired Product", "Damaged Product", "Wrong SKU Delivered", "Slow Moving SKU"];

    const [caseQty,setCaseQty] = useState(props.reasonObject.caseQty ?? 0);
    const [pieceQty,setPieceQty] = useState(props.reasonObject.pieceQty ?? 0);
    const [otherQty,setOtherQty] = useState(props.reasonObject.otherQty ?? 0);
    const [reason,setReason] = useState(props.reasonObject.reason);
    const [qtyError,setQtyError] = useState<boolean>(false);
    const [reasonError,setReasonError] = useState<boolean>(false);

    useEffect(()=>{

      setCaseQty(props.reasonObject.caseQty);
      setPieceQty(props.reasonObject.pieceQty);
      setOtherQty(props.reasonObject.otherQty);
      setReason(props.reasonObject.reason);
      if(props.currentErrorObj && props.currentErrorObj.quantityError){
        setQtyError(true);
      } else {
        setQtyError(false);
      }
      if(props.currentErrorObj && props.currentErrorObj.reasonError){
        setReasonError(true);
      }else{
        setReasonError(false);
      }
    },[props.reasonObject, props.selectedQuantity, props.currentErrorObj])
  
    useEffect(()=>{

        props.onChange({
          caseQty:caseQty,
          pieceQty:pieceQty,
          otherQty:otherQty,
          reason:reason,
        })
  
    },[reason,caseQty,pieceQty,otherQty])
    return (
        <div className="delivery-label-input-container-edit" style={{width: "100%"}}>
            <div className="cs-pc-container-edit">
            {caseUnitLabelPrimaryReturn && <CustomCsPcInput
                value={caseQty}
                onChange={(e) => {
                    const qty:number = convertStringToNumber(e.target.value, true);
                    if (props.validate(qty,caseQty,"caseQty")) setCaseQty(qty);
                }
                }
                label={caseUnitLabelPrimaryReturn}
                percentage={100}
                disabled={props.products?.caseToPieceQuantity === 0}
                borderColor={qtyError ? "#C44C36" : "#d9d9d9"}
            />}
            {otherUnitLabelPrimaryReturn && <CustomCsPcInput
                value={otherQty}
                onChange={(e) => {
                const qty:number = convertStringToNumber(e.target.value, true);
                if (props.validate(qty,otherQty,"otherQty")) setOtherQty(qty);
                }}
                label= {props.products?.otherUnitName ?? otherUnitLabelPrimaryReturn}
                percentage={100}
                disabled={props.products?.otherToPieceQuantity === 0}
                borderColor={qtyError ? "#C44C36" : "#d9d9d9"}
            />}
            {packUnitLabelPrimaryReturn && <CustomCsPcInput
                value={pieceQty}
                onChange={(e) => {
                const qty:number = convertStringToNumber(e.target.value, true);
                if (props.validate(qty,pieceQty,"pieceQty")) setPieceQty(qty);
                }}
                label={packUnitLabelPrimaryReturn}
                percentage={100}
                borderColor={qtyError ? "#C44C36" : "#d9d9d9"}
            />}
            </div>
            {props.selectedQuantity !== "REJECTED" &&
            <div style={{display: "flex", gap: "4px", alignItems: "center"}}>
                <div className="label-input-parent-edit">
                    <FormControl className="batch-editor-dropdown">
                        <Select
                        className="dropdown"
                        value={reason}
                        size="small"
                        sx={{ 
                          minWidth: "150px",
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: reasonError ? "#C44C36" : "#d9d9d9",
                          },
                          "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: reasonError ? "#C44C36" : "#000",
                          },
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: reasonError ? "#C44C36" : "#1976d2",
                          },
                        }}
                        onChange={(e) => setReason(e.target.value)}
                        displayEmpty
                        renderValue={(selected) =>
                            selected ? (
                            <span className="dropdown-selected-item">{selected}</span>
                            ) : (
                            <span className="dropdown-placeholder">Select a Reason</span>
                            )
                        }
                        >
                        {reasonArray.map((reason, index) => (
                            <MenuItem key={index} value={reason}>
                            <div className="dropdown-menu-item">{reason}</div>
                            </MenuItem>
                        ))}
                        </Select>
                    </FormControl>
                </div>
                {props.actionElement}
            </div>
            }
        </div>
    )
}
  
type ValidateFunctionType = (qty: number, prevQty: number, key: "pieceQty" | "caseQty" | "otherQty") => boolean;

const convertStringToNumber = (
  val: string,
  avoidException?: boolean,
  allowNegative: boolean = false
): number => {
  // Handle null or undefined
  if (val == null) {
    if (avoidException) return 0;
    throw new Error("Invalid input: value is null or undefined");
  }

  // Trim whitespace
  const trimmed = val.trim();

  // Handle empty string
  if (trimmed === "") {
    return 0;
  }

  // Attempt to parse
  const num = Number(trimmed);

  // Check for NaN
  if (isNaN(num) || !isFinite(num)) {
    if (avoidException) return 0;
    throw new Error("Invalid entry: not a valid number");
  }

  // Check for negative values
  if (!allowNegative && num < 0) {
    if (avoidException) return 0;
    throw new Error("Invalid entry: negative values not allowed");
  }

  // Optional: cap absurdly large numbers
  if (Math.abs(num) > 1e9) {
    if (avoidException) return 0;
    throw new Error("Invalid entry: number too large");
  }

  return num;
};

export default PrimaryReturnReasonSelect;
